"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hydrateStrategyMatrixQueryState = exports.strategyMatrixFieldHydrators = void 0;
const strategy_matrix_query_params_models_1 = require("./strategy-matrix-query-params.models");
const store_1 = require("../../store");
const hasCompactCategories = (value) => (Array.isArray(value));
const isCompactChildrenSelection = (value) => (Boolean(value)
    && typeof value === 'object'
    && !Array.isArray(value)
    && value.selectAll === true
    && Array.isArray(value.excludedValues));
const strategyMatrixHydrationOrder = [
    strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.ExtendedFilter,
    strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.SelectedAttributes,
    strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.SelectedDisplayTable,
];
exports.strategyMatrixFieldHydrators = {
    [strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.ExtendedFilter]: ({ allCategoryIds = [], allChildIdsByCategoryId = {}, catalogId, dispatch, state, }) => {
        var _a;
        let extendedFilter = [];
        const stateExtendedFilter = state[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.ExtendedFilter];
        if (!Array.isArray(stateExtendedFilter)) {
            const excludedValuesSet = new Set((_a = stateExtendedFilter === null || stateExtendedFilter === void 0 ? void 0 : stateExtendedFilter.excludedValues) !== null && _a !== void 0 ? _a : []);
            const includedCategoryIds = allCategoryIds.filter((id) => !excludedValuesSet.has(id));
            const categoryOverrides = hasCompactCategories(stateExtendedFilter === null || stateExtendedFilter === void 0 ? void 0 : stateExtendedFilter.categories)
                ? stateExtendedFilter.categories
                : [];
            if (!includedCategoryIds.length && !categoryOverrides.length) {
                extendedFilter = [];
            }
            else {
                const overridesByCategoryId = new Map(categoryOverrides.map((category) => [category.id, category]));
                extendedFilter = includedCategoryIds.map((id) => {
                    var _a;
                    const override = overridesByCategoryId.get(id);
                    if (!(override === null || override === void 0 ? void 0 : override.children)) {
                        return { id };
                    }
                    if (Array.isArray(override.children)) {
                        return Object.assign({ id }, (override.children.length ? { children: override.children } : {}));
                    }
                    const allChildIds = (_a = allChildIdsByCategoryId[id]) !== null && _a !== void 0 ? _a : [];
                    const childExcludedValuesSet = new Set(override.children.excludedValues);
                    const children = allChildIds.filter((childId) => !childExcludedValuesSet.has(childId));
                    return Object.assign({ id }, (children.length ? { children } : {}));
                });
            }
        }
        else {
            extendedFilter = stateExtendedFilter.map((category) => {
                var _a;
                if (!isCompactChildrenSelection(category.children)) {
                    return Object.assign({ id: category.id }, (category.children ? { children: category.children } : {}));
                }
                const allChildIds = (_a = allChildIdsByCategoryId[category.id]) !== null && _a !== void 0 ? _a : [];
                const excludedValuesSet = new Set(category.children.excludedValues);
                const children = allChildIds.filter((id) => !excludedValuesSet.has(id));
                return Object.assign({ id: category.id }, (children.length ? { children } : {}));
            });
        }
        dispatch((0, store_1.setSelectedDataForStrategyMatrix)(catalogId, {
            extendedFilter,
        }));
    },
    [strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.SelectedAttributes]: ({ catalogId, dispatch, state }) => {
        dispatch((0, store_1.setSelectedDataForStrategyMatrix)(catalogId, {
            selectedAttributes: state[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.SelectedAttributes],
        }));
    },
    [strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.SelectedDisplayTable]: ({ catalogId, dispatch, state }) => {
        dispatch((0, store_1.setSelectedDataForStrategyMatrix)(catalogId, {
            selectedDisplayTable: state[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.SelectedDisplayTable],
        }));
    },
};
const hydrateStrategyMatrixQueryState = (context) => {
    strategyMatrixHydrationOrder.forEach((field) => {
        if (field in context.state) {
            exports.strategyMatrixFieldHydrators[field](context);
        }
    });
};
exports.hydrateStrategyMatrixQueryState = hydrateStrategyMatrixQueryState;
